import {find} from "@elements/dom-utils";

let loadingOverlayNode;
export function init() {
    loadingOverlayNode = find('.js-planer__loading');
    removeGetParameters();
}
export function enableLoadingOverlay() {
    loadingOverlayNode.removeAttribute('hidden');
}

export function disableLoadingOverlay() {
    loadingOverlayNode.setAttribute('hidden', true);
}

function removeGetParameters() {
    history.replaceState({}, document.title, location.pathname + location.hash);
}

// var terracePlannerApplicationLoading = (function ($, loadingOverlayNode) {
//
//     /**
//      * greys out the page's content and shows a loading gif
//      */
//     var enableLoadingOverlay = function () {
//         loadingOverlayNode.removeClass('hidden');
//     };
//
//     /**
//      * hides the loading animation greying out the page's content
//      */
//     var disableLoadingOverlay = function () {
//         loadingOverlayNode.addClass('hidden');
//     };
//
//     /**
//      * removes GET parameters from the current url
//      * so a terrace loaded by id or share code is loaded and placed in the session only once
//      */
//     var removeGetParameters = function () {
//         history.replaceState({}, document.title, location.pathname + location.hash);
//     };
//
//     /**
//      * initializes modules vars
//      */
//     var init = function () {
//         loadingOverlayNode = $('#applicationLoadingOverlay');
//         removeGetParameters();
//     };
//
//     return {
//         init: init,
//         enable: enableLoadingOverlay,
//         disable: disableLoadingOverlay
//     };
// })(jQuery);